$shm_service_workspace $mol_book2
	task_list null $mol_view
	dashboard null $mol_view
	filters null $mol_view
	pages <= workspace_pages /
	workspace_pages /
